import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';

// componets
import Task from './Task';

// icones 
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
//Hooks
import { useState, useContext } from 'react';

import { TaskContext } from '../Context/TaskContex';
export default function Tasks() {
    const { allTasks, addTask, completed, notCompleted, editTask } = useContext(TaskContext)
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState({ title: "", details: "" });
    const [openEdit, setOpenEdit] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [activeFilter, setActiveFilter] = useState("all")
    let changeFilter = allTasks
    if (activeFilter === "completed") {
        changeFilter = completed
    } else if (activeFilter === "non-completed") {
        changeFilter = notCompleted
    } else {
        changeFilter = allTasks
    }
    function handleActive(e) {
        setActiveFilter(e.target.value)
    }
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClickOpenEdit = () => {
        setOpenEdit(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        if (formJson.title.trim().length === 0) {
            alert("يرجى إدخال عنوان للمهمة"); // اختيارياً: يمكنك استخدام تنبيه أو خطأ MUI
            return;
        }
        addTask(formJson.title, formJson.details);
        handleClose();
    };


    /// update function
    const showedit = (task) => {
        setEditData(task)
        handleClickOpenEdit()
    };
  const handleClickAlert = () => {
    setOpenAlert(true);
  };
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };
    const handleUpdateSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        if (formJson.title.trim().length === 0) {
             handleClickAlert()
             return;
        }
        // استدعاء دالة التعديل من الـ Context
        editTask(editData.id, formJson.title, formJson.details);

        handleCloseEdit();
    };





    return (
        <>
                  
            <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth sx={{ direction: "rtl" }}>
                <DialogTitle>تعديل المهمة</DialogTitle>
                {/* نموذج واحد يضم كل الحقول */}
                <form onSubmit={handleUpdateSubmit} >
                    <DialogContent>
                        <TextField
                            name="title" // لعنوان المهمة
                            label="عنوان المهمة"
                            fullWidth
                            variant="standard"
                            defaultValue={editData.title}
                            required
                            margin='normal'
                            sx={textFieldStyle}
                        />
                        <TextField
                            name="details" // لتفاصيل المهمة
                            label="تفاصيل المهمة"
                            fullWidth
                            variant="standard"
                            margin='normal'
                            defaultValue={editData.details} // نضع القيمة القديمة كافتراضية
                            required
                            sx={textFieldStyle}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseEdit}>إلغاء</Button>
                        {/* هذا الزر سيقوم بإرسال النموذج أعلاه */}
                        <Button type="submit" color="primary">حفظ التغييرات</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Container maxWidth="sm">
                <Card sx={scrollStyle2}>
                    <CardContent
                    //  sx={scrollStyle}
                    >
 <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        message="لايمكن حفظ مهمه فارغة !"
      />
                        <Typography variant='h2'>
                            إنجازى
                        </Typography>
                        <Divider />
                        {/* ازرار الفلتره */}
                        <ToggleButtonGroup size='small'
                            style={{ marginTop: "30px", direction: "ltr" }}
                            value={activeFilter}
                            exclusive
                            onChange={handleActive}
                            aria-label="text alignment">
                            <ToggleButton value="non-completed"> غير المنجز</ToggleButton>
                            <ToggleButton value="completed">المنجز</ToggleButton>
                            <ToggleButton value="all" >الكل</ToggleButton>
                        </ToggleButtonGroup>
                        {/*=====ازرار الفلتره====== */}
                        {/*========================================================= */}
                        {/*المهام */}
                        {changeFilter.map((t) => (
                            <Task
                                key={t.id} task={t} showUpdate={showedit}
                            />
                        ))}
                        {/*====المهام==== */}
                        <div>
                            <Fab color="primary" aria-label="add"
                                onClick={handleClickOpen}
                                sx={{ marginTop: "10px" }}>
                                <AddIcon />
                            </Fab>
                        </div>
                        <Dialog open={open} onClose={handleClose} fullWidth sx={{ direction: "rtl" }}>
                            <DialogTitle>إضافة مهمة</DialogTitle>
                            {/* نموذج واحد يضم كل الحقول */}
                            <form onSubmit={handleSubmit} id="subscription-form">
                                <DialogContent>
                                    <TextField
                                        autoFocus
                                        required
                                        margin="dense"
                                        name="title" // لعنوان المهمة
                                        label="عنوان المهمة"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        sx={textFieldStyle}
                                    />
                                    <TextField
                                        required
                                        margin="dense"
                                        name="details" // لتفاصيل المهمة
                                        label="تفاصيل المهمة"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        sx={textFieldStyle}
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>إلغاء</Button>
                                    {/* هذا الزر سيقوم بإرسال النموذج أعلاه */}
                                    <Button type="submit">إضافة</Button>
                                </DialogActions>
                            </form>
                        </Dialog>

                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
const textFieldStyle = {
    '& .MuiInputBase-input': { textAlign: 'right' },
    '& .MuiInputLabel-root': {
        right: 0, left: 'auto', transformOrigin: 'top right',
        '&.Mui-focused, &.MuiFormLabel-shrink': { transform: 'translate(0, 1.5px) scale(0.75)' }
    }
};



const scrollStyle2 = {
    minWidth: 275,
    maxHeight: "86vh",
    overflowY: "auto",

    // 1. المتصفحات المبنية على Webkit (Chrome, Safari, Edge)
    '&::-webkit-scrollbar': {
        width: '6px', // عرض شريط التمرير
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'transparent', // مخفي تماماً في الحالة العادية
        borderRadius: '10px',
    },

    // 2. يظهر فقط عند تمرير الماوس فوق الحاوية (CardContent)
    '&:hover::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)', // يظهر بلون رمادي خفيف وشفاف
    },

    // 3. لدعم متصفح Firefox
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent', // مخفي (لون المقبض ولون الخلفية شفافين)
    '&:hover': {
        scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent', // يظهر المقبض عند Hover
    }
};

